import { postData } from '../utils/api';

/**
 * Gửi thông tin contact tới backend
 * @param {Object} contactData 
 * @returns {Promise}
 */
export const sendRegisterAsADistributorMail = (contactData) => {
  return postData('/api/register-as-a-distributor', contactData);
};
